<template>
    <main class="skiplink-target main" id="content" tabindex="-1">
        <div class="container">
            <header class="row">
                <div class="col-xl-8 col-xl-offset-2 col-lg-10 col-lg-offset-1">
                    <div class="content content--header">
                        <section class="content-header">
                            <h1>{{labels.gegevensControleren.kop}}</h1>
                            <p>{{labels.gegevensControleren.stapIndicator}}</p>
                        </section>
                    </div>
                </div>
            </header>
            <article>
                <div class="row">
                    <div class="col-xl-8 col-xl-offset-2 col-lg-10 col-lg-offset-1">
                        <div class="content-background">

                            <div v-bind:class="[inputClass, {'input--invalid': toonInvoerError}]">
                                <div  class="input__error" v-if="toonInvoerError">{{labels.errors.verplichtevelden}}</div>
                            </div>
                            <div class="content">
                                <div class="edit-section">
                                    <h2>{{labels.gegevensControleren.subkopReden}}</h2>
                                    <router-link
                                            :to="{name:'reden-contact'}">{{labels.algemeen.wijzigInvoer}}
                                    </router-link>
                                </div>
                                <ul class="definition-list">
                                    <li class="definition-list__item definition-list__item--horizontal">
                                        <div class="definition-list__item__title">{{labels.gegevensControleren.reden}}</div>
                                        <div class="definition-list__item__description break-all">
                                            <p>{{redenContactItem.label}}</p>
                                        </div>
                                    </li>
                                </ul>
                            </div>


                            <div class="content" v-if="vraag">
                                <div class="edit-section">
                                    <h2>{{labels.gegevensControleren.subkopVraag}}</h2>
                                    <router-link :to="{name: 'vraag'}">
                                        {{labels.algemeen.wijzigInvoer}}
                                    </router-link>
                                </div>
                                <ul class="definition-list">
                                    <li class="definition-list__item definition-list__item--horizontal">
                                        <div class="definition-list__item__title">{{labels.gegevensControleren.vraag}}</div>
                                        <div class="definition-list__item__description break-all">
                                            <p>{{vraag}}</p>
                                        </div>
                                    </li>
                                </ul>
                            </div>


                            <div class="content">
                                <div class="edit-section">
                                    <h2>{{labels.gegevensControleren.subkopPersonalia}}</h2>
                                    <router-link
                                            :to="{name: 'gegevens-invoeren'}">{{labels.algemeen.wijzigInvoer}}
                                    </router-link>
                                </div>
                                <ul class="definition-list">
                                    <li class="definition-list__item definition-list__item--horizontal">
                                        <div class="definition-list__item__title">{{labels.gegevensControleren.naam}}</div>
                                        <div class="definition-list__item__description break-all">
                                            <p>{{roepnaam}}</p>
                                        </div>
                                    </li>
                                    <li v-if="bsnRequired && form.gegevens.bsn" class="definition-list__item definition-list__item--horizontal">
                                        <div class="definition-list__item__title">{{labels.gegevensControleren.bsn}}</div>
                                        <div class="definition-list__item__description break-all">
                                            <p>{{form.gegevens.bsn}}</p>
                                        </div>
                                    </li>
                                </ul>
                            </div>

                            <div class="content"  v-if="adresRequired">
                                <div class="edit-section">
                                    <h2>{{labels.gegevensControleren.subkopAdres}}</h2>
                                    <router-link
                                            :to="{name: 'gegevens-invoeren'}">{{labels.algemeen.wijzigInvoer}}
                                    </router-link>
                                </div>
                                <ul class="definition-list">
                                    <li v-if="adresRequired && !buitenlandsAdres" class="definition-list__item definition-list__item--horizontal">
                                        <div class="definition-list__item__title">{{labels.gegevensControleren.adres}}</div>
                                        <div class="definition-list__item__description break-all">
                                            <p>{{adresGegevens.straat}}</p>
                                        </div>
                                    </li>
                                    <li v-if="adresRequired && !buitenlandsAdres" class="definition-list__item definition-list__item--horizontal">
                                        <div class="definition-list__item__title">{{labels.gegevensControleren.postcode}}</div>
                                        <div class="definition-list__item__description break-all">
                                            <p>{{adresGegevens.postcode}}</p>
                                        </div>
                                    </li>
                                    <li v-if="adresRequired && !buitenlandsAdres" class="definition-list__item definition-list__item--horizontal">
                                        <div class="definition-list__item__title">{{labels.gegevensControleren.plaats}}</div>
                                        <div class="definition-list__item__description break-all">
                                            <p>{{adresGegevens.plaats}}</p>
                                        </div>
                                    </li>
                                    <li v-if="adresRequired && buitenlandsAdres" class="definition-list__item definition-list__item--horizontal">
                                        <div class="definition-list__item__title">{{labels.gegevensControleren.adres}}</div>
                                        <div class="definition-list__item__description break-all">
                                            <p>{{adresGegevens.adresbuitenland}}</p>
                                        </div>
                                    </li>
                                </ul>
                            </div>


                            <div class="content" v-if="contactGegevens.emailAdres || contactGegevens.telefoonnummer">
                                <div class="edit-section">
                                    <h2>{{labels.gegevensControleren.subkopContactgegevens}}</h2>
                                    <router-link :to="{name: 'gegevens-invoeren'}">
                                        {{labels.algemeen.wijzigInvoer}}
                                    </router-link>
                                </div>

                                <ul class="definition-list">
                                    <li v-if="contactGegevens.emailAdres" class="definition-list__item definition-list__item--horizontal">
                                        <div class="definition-list__item__title">{{labels.gegevensControleren.email}}</div>
                                        <div class="definition-list__item__description break-all">
                                            <p>{{contactGegevens.emailAdres}}</p>
                                        </div>
                                    </li>
                                    <li v-if="contactGegevens.telefoonnummer > 0"
                                        class="definition-list__item definition-list__item--horizontal">
                                        <div class="definition-list__item__title">{{labels.gegevensControleren.telefoon}}</div>
                                        <div class="definition-list__item__description break-all">
                                            <p>{{contactGegevens.telefoonnummer}}</p>
                                        </div>
                                    </li>
                                </ul>

                            </div>

                            <div class="content">
                                <div class="captcha">
                                    <img :src="captchaSrc" id="sCaptcha" style="width: 300px; max-width: 100%" ref="sCaptcha"/>
                                    <button class="btn captchaKnop" v-on:click="setCaptcha">vernieuw</button>
                                </div>
                                <div v-bind:class="[inputClass, {'input--invalid': toonCaptchaError}]">
                                    <label  class="input__label" for="captcha">{{labels.gegevensControleren.captchaInstructie}}</label>

                                    <div class="input__error" v-if="toonCaptchaError">{{labels.errors.geldigCaptcha}}
                                    </div>
                                    <input type="text" id="captcha"
                                           class="input__control input__control--m input__control--text"
                                           v-model="captchaInput">
                                </div>

                                <p>
                                    <button id="verzendButton" v-bind:class="[btnClass]" @click="gaVerder">{{labels.algemeen.verzenden}}
                                    </button>
                                    {{labels.algemeen.of}}
                                    <router-link :to="{name: 'gegevens-invoeren'}">{{labels.algemeen.labelVorige}}
                                    </router-link>
                                </p>

                            </div>

                        </div>
                    </div>
                </div>
            </article>
        </div>
    </main>
</template>

<script>
    import { useVuelidate } from '@vuelidate/core'
    import {mapGetters} from 'vuex';
    import axios from 'axios'

    export default {
        name: "controleren",
        setup () {
            return {
                v$: useVuelidate()
            }
        },
        data() {
            return {
                inputClass: 'input',
                btnClass: 'btn btn--primary',
                btnSecundairClass: 'btn',
                toonCaptchaError: false,
                toonInvoerError: false
            }
        },
        methods: {
            gaVerder() {
                this.v$.$touch();

                document.getElementById("verzendButton").disabled = true;
    
                if (!this.v$.$error) {
                    this.sendMailTo();
                }
            },
            setCaptcha() {
                this.$refs.sCaptcha.src = '/captchaimg?v=' + Date.now();
            },
            setInput(event, type) {
                let x = {type, value: event.target.value}
                this.$store.commit('setPersoonsGegevens', x)
            },
            sendMailTo(){
                axios.post('/zakelijk/system/mail/kinderopvang.jsp', JSON.stringify(this.sendMail))
                .then(response => {
                    if (response.data.success){
                        document.getElementById("verzendButton").disabled = true;
                        this.toonCaptchaError = false;
                        this.$router.push({name: 'bevestigen'})
                    }
                    else {
                         if (response.data.errors[0] == "verzenden") {
                             this.$router.push({name: 'error'});
                         }
                         else if (response.data.errors[0] == "captcha"){
                            document.getElementById("verzendButton").disabled = false;
                            document.getElementById("captcha").value = "";
                            this.toonCaptchaError = true;
                         }
                         else{
                             this.toonInvoerError = true;
                         }
                    }
                })
                    .catch(error => console.log(error));

            }
        },
        computed: {
            ...mapGetters(['sendMail', 'contactredenen', 'redenContact', 'contactGegevens', 'vraag', 'persoonsGegevens', 'roepnaam', 'labels', 'redenContactItem', 'adresGegevens', 'veldopties', 'form', 'toonCaptchaInfo']),
            captchaSrc() {
                return '/captchaimg?v=' + Date.now()
            },
            captchaInput: {
                set(x) {
                    this.$store.commit('setCaptcha', x)
                },
                get() {
                    return this.$store.state.form.gegevens.captchaInput
                }
            },
            adresRequired() {
                if (this.veldopties && this.veldopties.adres) {
                    return true;
                } else {
                    return false;
                }
            },
            buitenlandsAdres() {
                return this.$store.state.form.gegevens.adresGegevens.land !== 'nl'
            },
            bsnRequired() {
                if (this.veldopties && this.veldopties.bsn) {
                    return true;
                } else {
                    return false;
                }
            }
        },
        created() {
            this.$trackPageView('Controleren');              
        },
        validations: {
            captchaInput() {
                return true;
            }
    }}
</script>

<style scoped>
    .definition-list__item--parent {
        border-bottom: none;
    }

    .captcha {
        align-items: center;
        margin-bottom: 10px;
    }


    @media (min-width: 768px) {
        .captcha {
            display: flex;
        }
        .captchaKnop {
            margin-left: 16px;
        }
    }

</style>
